import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';

import { getSellerCashOutFee, resetDisbursementSetting } from "../../../actions/disbursementAction";

import { ModalPassword, ModalCashOut, ModalCashOutConfirmation, ModalCashOutInformation } from './index';
import { isNumeric } from '../../../helpers/regex';
import { addError } from '../../../utils/Helpers';

class CashoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _value: 0,
      _step: 1,
      _bankSelected: null,
      _error: null,
      _dataResult: {},
      _isAlertErrorOpen: false,
      _alertErrorMsg: '',
      _password: '',
      _errorMessage: '',
      _selectedCreditType: this.props.title,
      isGettingFee: false
    };

    this._handleValueChange = this._handleValueChange.bind(this);
    this._handleOnToggle = this._handleOnToggle.bind(this);
    this._handleNextStep = this._handleNextStep.bind(this);
    this._handleGetBalance = this._handleGetBalance.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleOnToggleAlertError = this._handleOnToggleAlertError.bind(this);
    this._handlePassword = this._handlePassword.bind(this);
    this._throttleGetDisbursementFee = _.debounce(this._getDisbursementFee.bind(this), 500)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dataDisburse.isSubmit
      && prevProps.dataDisburse.isSubmit !== this.props.dataDisburse.isSubmit) {
      const { error, data } = this.props.dataDisburse;
      if (error) {
        if (error.status_code === 422) {
          const passwordKeyProps = Object.keys(error.errors).find(key => key === 'password');
          if (passwordKeyProps) {
            error.errors[passwordKeyProps] = ['Incorrect password'];
          }
          this.setState({
            _error: {
              ...this.state._error,
              ...error
            }
          })
        } else if (error.status_code === 500) {
          let errors = null;
          if (error.message === "User has wallet payment or disbursement still pending.") {
            errors = {
              password: ['Sorry, your request cannot be processed. You still have wallet payment or cash out pending.']
            };
          }
          else {
            errors = {
              password: ['Sorry, we have a problem!. Please inform our friendly staff via Whatsapp +6281210005425.']
            };
          }
          this.setState({
            _error: {
              ...this.state._error,
              errors
            }
          })
        } else {
          //Stay here and show error message
          this.setState({
            _error: error,
            _errorMessage: error.message == 'Your previous cashout is still in process. Please wait for a moment' ? 'Please wait until your on going request is approved' : error.message,
            _isAlertErrorOpen: true,
            _alertErrorMsg: this._getErrorMsg(error.status_code)
          })
        }
      }
      else {
        this.setState({
          _dataResult: data,
          _error: null,
          _isAlertErrorOpen: false
        })
        this._handleNextStep(4);
      }
    }
    if (prevProps.isOpen && prevProps.isOpen !== this.props.isOpen) {
      //Clearing Form maybe...
      this.setState({
        _error: null,
        _isAlertErrorOpen: false,
        _bankSelected: null,
        _dataResult: null,
        _value: this.state._dataResult !== null && this.state._dataResult.id ? 0 : this.state._value
      })
    }
  }

  _getErrorMsg(statusCode) {
    return statusCode !== 200 ? `Oops, something went wrong. (code: ${statusCode})` : null
  }

  _getDisbursementFee = async (totalAmount) => {
    if (totalAmount > 0) {
      await this.props.getSellerCashOutFee({ total_amount: totalAmount });
      await this.setState({
        isGettingFee: false
      })
    }
  }

  async _handleValueChange(e, isSelectedType = this.props.title) {
    let dataCashout = { ...this.state._value }
    switch (e.target.name) {
      case '_value':
        dataCashout =
          e.target.value ? `${e.target.value.replace(/[\. ,:-]+/g, '')}.00` : '0.00'; break;

      default: return null
    }
    const payload = {
      _value: parseInt(dataCashout)
    }
    if (this.props.balance_source == "BALANCE_WITH_FEE" || isSelectedType === "Seller Credit") {
      payload.isGettingFee = true
    }
    await this.setState(payload, () => {
      if (this.props.balance_source == "BALANCE_WITH_FEE" || isSelectedType === "Seller Credit") this._throttleGetDisbursementFee(parseInt(dataCashout));
    })
  }

  _handlePassword(e) {
    this.setState({ _password: e.target.value });
  }

  _handleOnToggle() {
    if (!this.props.dataDisburse.isSubmit) {
      this.setState({
        _step: 1
      })
      this.props.onToggle()
    }

    if (this.state._step === 3) {
      this.setState({ _password: '' })
    }
  }

  _handleNextStep(step, creditType = this.state._selectedCreditType) {
    this.setState({ _selectedCreditType: creditType })

    if (step === 2) {
      const errors = this._validationForm();
      if (this._hasErrorForm(errors)) {
        this.setState({
          _error: {
            ...this.state._error,
            errors
          }
        })
      }
      else {
        const { account_number, bank_name, account_name, branch, id } = this.props.bankAccount[0];
        this.setState({
          _step: step,
          _error: null,
          _isAlertErrorOpen: false,
          _bankSelected: {
            bank_name,
            account_number,
            account_name,
            branch: branch,
            id
          }
        })
      }
    }
    else {
      this.setState({
        _step: step > 0 || step < 4 ? step : 1
      })
    }
  }

  _handleGetBalance() {
    this.props.balance()
  }

  _validationForm() {
    let errors = {};
    if (!isNumeric(this.state._value))
      errors['total_amount'] = addError(errors, 'total_amount', 'The total amount field must be numeric.');
    if (this.props.bankAccount.length === 0)
      errors['total_amount'] = addError(errors, 'total_amount', 'Please fulfill your bank account!');
    return errors;
  }

  _hasErrorForm(errors) {
    return Object.keys(errors).length > 0;
  }

  _handleSubmit(e) {
    e.preventDefault();
    const errors = this._validationForm();
    if (this._hasErrorForm(errors)) {
      this.setState({
        _error: {
          ...this.state._error,
          errors
        }
      })
    } else {
      const { _bankSelected, _selectedCreditType } = this.state;
      const amountFee = this.props.dataCashOutFee.amount_fee;
      const balanceSource = _selectedCreditType === "Kick Credit" ? "BALANCE" : "BALANCE_WITH_FEE";

      this.props.onSubmit({
        total_amount: this.state._value,
        fee: amountFee,
        balance_source: balanceSource,
        disbursement_bank: {
          branch_recipient: _bankSelected.branch,
          bank_account_id_recipient: _bankSelected.id
        },
        password: this.state._password
      })
      this.setState({
        _error: null,
        _isAlertErrorOpen: false,
      })
    }
    this.setState({
      _password: ''
    })
  }

  _isModalOpen(step) {
    return this.props.isOpen && this.state._step === step
  }

  _handleOnToggleAlertError() {
    this.setState({
      _isAlertErrorOpen: !this.state._isAlertErrorOpen
    })
  }

  _getErrorPassword() {
    if (this.state._error && this.state._error.errors) {
      const passwordError = Object.keys(this.state._error.errors).find(key => key === "password");
      return passwordError !== undefined ? this.state._error.errors[passwordError][0] : null;
    } else if (this.state._error && this.state._errorMessage !== '') {
      return true;
    }
    return null;
  }

  _goToWalletHistory() {
    this._handleOnToggle()
    this.props.handleChangeTabs();
  }


  render() {
    const userBalance = this.state._selectedCreditType === "Kick Credit" ? this.props.dataUser.balance : this.props.dataUser.balance_with_fee;

    return (
      <div>
        <ModalCashOut
          title={this.state._selectedCreditType}
          icon={this.props.icon}
          value={this.state._value}
          amountFee={this.props.dataCashOutFee.amount_fee}
          isOpen={this._isModalOpen(1)}
          dataBank={this.props.bankAccount.length > 0 ? this.props.bankAccount[0] : {}}
          dataSetting={this.props.dataSetting}
          onTextChange={this._handleValueChange}
          onToggle={this._handleOnToggle}
          onNextPage={this._handleNextStep}
          balance={userBalance}
          error={this.state._error}
          hasOptions={this.props.hasOptions}
          onResetDisbursementSetting={this.props.resetDisbursementSetting}
          onGetDisbursementFee={this._getDisbursementFee}
          isGettingFee={this.state.isGettingFee}
        />
        <ModalCashOutConfirmation
          title={this.state._selectedCreditType}
          icon={this.props.icon}
          value={this.state._value}
          amountFee={this.props.dataCashOutFee.amount_fee}
          isOpen={this._isModalOpen(2)}
          dataBank={this.state._bankSelected}
          balance={userBalance}
          onToggle={this._handleOnToggle}
          onNextPage={this._handleNextStep}
          onSubmit={this._handleSubmit}
          errorMessage={this.state._alertErrorMsg}
          isAlertErrorOpen={this.state._isAlertErrorOpen}
          onAlertErrorToggle={this._handleOnToggleAlertError}
        />
        <ModalPassword
          isOpen={this._isModalOpen(3)}
          onClick={this._handleSubmit}
          onToggle={this._handleOnToggle}
          onTextChange={this._handlePassword}
          errorMessage={this.state._errorMessage}
          value={this.state._password}
          titleModal="Enter Password"
          error={this._getErrorPassword()}
          hasPassword={this.props.dataPassword}
          isSubmit={this.props.dataDisburse.isSubmit}
        />
        <ModalCashOutInformation
          title={this.state._selectedCreditType}
          icon={this.props.icon}
          onToggle={this._handleOnToggle}
          dataBank={this.state._bankSelected}
          balance={userBalance}
          isOpen={this._isModalOpen(4)}
          result={userBalance}
          goToWalletHistory={() => this._goToWalletHistory()}
        />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  getSellerCashOutFee: (query: any) => dispatch(getSellerCashOutFee(query)),
  resetDisbursementSetting: () => dispatch(resetDisbursementSetting())
})

const mapStateToProps = (state) => ({
  dataSetting: state.dataDisbursement.disbursementSetting,
  dataUser: state.dataAuth.userdata,
  dataCashOutFee: state.dataDisbursement.cashoutFee
})

export default connect(mapStateToProps, mapDispatchToProps)(CashoutForm);